export default __webpack_public_path__ + "static/media/carteirinha-imagem.0178173c.svg";